import React from 'react';
import './WhyUs.css';

const reasons = [
  { num: '01', title: '24/7 Support', desc: 'Round-the-clock availability for urgent staffing needs and operational emergencies.' },
  { num: '02', title: 'Trained & Verified Staff', desc: 'Every worker undergoes background checks, skills training, and safety induction.' },
  { num: '03', title: 'Fast Deployment', desc: 'We can mobilize workforce within 24–48 hours for urgent industrial requirements.' },
  { num: '04', title: 'Legal Compliance', desc: 'Full PF, ESI, Gratuity, and labour contract compliance — zero legal headaches for you.' },
  { num: '05', title: 'Experienced Supervisors', desc: 'On-site supervisors ensure quality output, discipline, and seamless coordination.' },
  { num: '06', title: 'Trusted by Industry', desc: '15+ companies across MIDC zones trust SSM for consistent, reliable manpower.' },
  { num: '07', title: 'Emergency Service', desc: 'Sudden absenteeism? We fill workforce gaps the same day — no production halts.' },
  { num: '08', title: 'Professional Management', desc: 'Dedicated account managers, regular performance reviews, and transparent reporting.' },
];

const WhyUs = () => (
  <section className="why section-light" id="why">
    <div className="container">
      <span className="section-label">Why SSM Services</span>
      <h2 className="section-title">The <span>SSM Advantage</span></h2>
      <div className="divider" />
      <div className="why-grid">
        {reasons.map((r) => (
          <div className="why-card" key={r.num}>
            <div className="why-num">{r.num}</div>
            <div className="why-body">
              <div className="why-title">{r.title}</div>
              <div className="why-desc">{r.desc}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default WhyUs;
